import { Campaign } from "./campaign"
import { CampaignReport } from "./campaign_report"
import { BirthdayCampaign } from "./birthday_campaign"

export class Birthday {
    constructor(birthday) {
        this.campaign          = new Campaign(birthday);
        this.campaign_report   = new CampaignReport(birthday.campaign_report);
        this.birthday_campaign = new BirthdayCampaign(birthday.birthday_campaign);
    }
}